<template>
  <v-container style="padding-top: 10px">
    <div v-if="graphData.length > 0">
      <v-row style="padding: 10px; border: 1px solid #ccc; border-radius: 5px">
        <v-col cols="3">
          Total function used: <br />
          <strong> {{ totalFunctions }} </strong>
        </v-col>
        <v-col cols="3">
          Average function per tag:<br />
          <strong> {{ averageFunctionPerTag }} </strong>
        </v-col>
        <v-col cols="3">
          Total unique tags:<br />
          <strong> {{ totalUniqueTags }} </strong>
        </v-col>
        <v-col cols="3">
          Total unique users:<br />
          <strong> {{ totalUniqueUsers }} </strong>
        </v-col>
      </v-row>
      <v-row style="padding: 10px; padding-top: 20px">
        <v-chart
          :option="chartOption"
          :style="{ height: '400px', width: '100%' }"
          autoresize
        />
      </v-row>
    </div>
  </v-container>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "@carbon/styles/css/styles.css";
import "@carbon/charts/styles.css";

export default {
  components: {
    "v-chart": ECharts,
  },
  props: ["clientUsageData"],
  data: () => ({
    // Removed unused options and pure-vue-chart config
  }),
  mounted() {
    console.log(this.graphData);
  },
  methods: {},
  computed: {
    chartOption() {
      const dates = this.graphData.map(item => item.date);
      const values = this.graphData.map(item => item.functionCount);
      
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            const date = new Date(params[0].name);
            const formatted = date.toLocaleString('en-US', { 
              month: 'long', 
              year: 'numeric' 
            });
            return `${formatted}<br/>Functions: <strong>${params[0].value}</strong>`;
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: {
            rotate: 45,
            interval: Math.ceil(dates.length / 20), // Show ~20 labels max
            formatter: (value) => {
              const date = new Date(value);
              return date.toLocaleString('en-US', { 
                month: 'short', 
                year: '2-digit' 
              });
            }
          },
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value',
          name: 'Function Count',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: 'Function Calls',
            type: 'bar',
            data: values,
            itemStyle: {
              color: '#167595'
            },
            barMaxWidth: 40
          }
        ],
        dataZoom: [
          {
            type: 'slider',
            show: true,
            start: 0,
            end: 100,
            height: 20,
            bottom: 5
          },
          {
            type: 'inside',
            start: 0,
            end: 100
          }
        ]
      };
    },
    graphData() {
      let simplified = [];
      if (this.clientUsageData.access) {
        this.clientUsageData.access.forEach((element) => {
          let tempobj = {};
          tempobj["group"] = element.group;
          tempobj["functionCount"] = element.FunctionCount;
          tempobj["date"] = element.date;
          simplified.push(tempobj);
        });
      }
      return simplified;
    },
    totalFunctions() {
      return this.clientUsageData.totalFunctions;
    },
    averageFunctionPerTag() {
      return this.clientUsageData.averageFunctionPerTag;
    },
    totalUniqueTags() {
      return this.clientUsageData.totalUniqueTags;
    },
    totalUniqueUsers() {
      return this.clientUsageData.totalUniqueUsers;
    },
  },
};
</script>
<style>
.my-chart {
  width: 800px;
  height: 500px;
}
</style>
